module.exports = __webpack_public_path__ + "media/pick-answer-merged.8312c8da.webm";